import useModalWithContext from '../../../../hooks/useModalWithContext';
import type { ModalStateWithContext } from '../../../../hooks/useModalWithContext';

import { type ManagePackageLabelsState, useManagePackageLabelsModal } from './useManagePackageLabelsModal';

type ViewRelationshipsModalState = {
  revision?: string;
  title?: string;
};

type ViewBinaryMatchDetailsModalState = {
  revision?: string;
};

export type DependencyV2Modals = {
  managePackageLabelsModal: ModalStateWithContext<ManagePackageLabelsState>;
  viewRelationshipsModal: ModalStateWithContext<ViewRelationshipsModalState>;
  viewBinaryMatchDetailsModal: ModalStateWithContext<ViewBinaryMatchDetailsModalState>;
};

/**
 * This is a wrapper hook to provide all the modals for the dependency page.
 * This will contain multiple modals in the future.
 * @returns {DependencyV2Modals} modal contexts
 */
const useDependencyModals = (): DependencyV2Modals => {
  const managePackageLabelsModal = useManagePackageLabelsModal();
  const viewRelationshipsModal = useModalWithContext<ViewRelationshipsModalState>({});
  const viewBinaryMatchDetailsModal = useModalWithContext<ViewBinaryMatchDetailsModalState>({});

  return {
    managePackageLabelsModal,
    viewRelationshipsModal,
    viewBinaryMatchDetailsModal,
  };
};

export default useDependencyModals;
